<script>
    import { createEventDispatcher } from 'svelte';
    import tagService from '../../tag/service.js';
    import { notificate } from '../../../services/notification.js';
    import { flatten422Errors } from '../../../services/api.svelte.js';
    import { translateErrorMessages } from '../../../services/api.svelte.js';
    import { format } from 'svelte-i18n';

    const dispatch = createEventDispatcher();

    export let asset;

    let formData = {};
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors
    let formApiErrors = {};
    let tags = [];
    let search_results;
    let showDropdown = false;
    let tagsToRemove    = [];
    let tagsAssociated  = [];
    let assetKind;
    let is_edit;

    // add form
    if (!asset) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: asset.name,
        };
        is_edit = true;
        tagsAssociated = asset.tag ? JSON.parse(asset.tag) : [];
    }

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        if(asset){
            for(let tag of tagsToRemove){
                let reqData = {
                    tag_id            : tag.id,
                    target_object_type: "Asset",
                    target_object_id  : asset.id
                }
                tagService.deleteAssociation(reqData, [], {})
                    .then(async savedTag => {
                        dispatch("removeTags", {savedTag});
                        //clear formData and form status and errors
                        // when modal is closed after sending add request
                        formData = {};
                        formIsSubmitted = false;
                        formApiErrors = {}
                        return true;
                    })
                    .catch(errors => {
                        if(typeof(errors.detail) == 'string'){
                            APIerror = translateErrorMessages(errors.detail, "Etiquetas");
                        }
                        else {
                            // parse API errors
                            formApiErrors = flatten422Errors(errors);
                        }
                        return false;
                    })
                ;
            }
        }
    }

    const removeAssociatedTag = (i, )=>{
        tagsToRemove.push(tagsAssociated[i]);
        tagsAssociated.splice(i, 1);
        tagsAssociated = tagsAssociated;
    }

    function handleCloseModal(){
        formData           = {};
        formApiErrors      = {};
        formIsSubmitted    = false;
        formIsSubmitted    = false;
        showDropdown       = true;
        APIerror           = null;
        assetKind          = null;
        tags             = [];
        search_results     = [];
    }


    const handleKeydown = event => {

        if(event.key == "Escape"){
            handleCloseModal();
        }
        else {
            return;
        }
    }
</script>
<style>
    .btnDeleteTag{
        cursor: pointer;
    }
</style>

<svelte:window on:keydown={handleKeydown}/>

<form role="form" novalidate on:submit|preventDefault={handleSubmit}>
    <div class="card">
        <div class="card-body">
            {#if asset}
                <div class="mb-3">
                    <label for="name">{$format("asset.word")}:</label>
                    <span class="d-block">{asset.nickname || asset.name || ''}</span>
                </div>
            {/if}
            <div class="mb-3">
                {#if tagsAssociated.length > 0}
                    <label for="tagsAssociated">{$format("form.fields.associated_tags")}:</label>
                {#each tagsAssociated as tag, i}
                    <div>{tag.name}<i class="fas fa-times btnDeleteTag float-end" on:click={()=>removeAssociatedTag(i, tagsAssociated)}></i></div>
                {/each}
            {/if}
            </div>

        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-asset-btn">{$format("buttons.save")}</button>
            <button class="btn btn-default" on:click={handleCloseModal} data-bs-dismiss="modal">{$format("buttons.cancel")}</button>
        </div>

    </div>
</form>
